import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WaiterService } from '../../_service/waiter.service';
import { AuthService } from '../../_service/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-confirm-order',
  standalone: true,
  imports: [RouterModule, FormsModule],
  templateUrl: './confirm-order.component.html',
  styleUrl: './confirm-order.component.scss'
})
export class ConfirmOrderComponent {
  service = inject(WaiterService)
  auth = inject(AuthService)
  router = inject(Router)
  name: string = '';
  email: string = '';
  phoneNumber: string = '';
  id: any;
  continue() {
    const user = this.auth.getUser('user')
    const storedObjectString = localStorage.getItem('orders');
    if (storedObjectString) {
      const userData = {
        name: this.name.trim(),
        email: this.email.trim(),
        phoneNumber: this.phoneNumber.trim(),
      };

      const myObject = JSON.parse(storedObjectString);
      const payload: any = {
        tab_open: true,
        ordered_by: "waiter",
        barcode_id: myObject.barcode_id,
        order_items: myObject.order_items,
        attendee_id: user.id
      };
      if (userData.phoneNumber) {
        payload.customer_phone = userData.phoneNumber;
      }
      if (userData.email) {
        payload.customer_email = userData.email;
      }
      if (userData.name) {
        payload.customer_name = userData.name;
      }
      this.service.storeOrder(payload).subscribe({
        next: (res: any) => {
          this.id = res.id;
          localStorage.removeItem('orders')
          localStorage.removeItem('cart')
          this.router.navigateByUrl(`/orders/${this.id}`)
        },
        error: (err) => {
          Swal.fire('Failed', err.error.message, 'error')
        },
        complete: () => {

        }
      })
    }



  }
}
